export const fwsed = {
  routes: [
    {
      path: "/fwsed/firm-management/:firmId/audit/:auditId/control",
      component: () => import("../firm-policy-detail"),
      props: true,
    },
  ],
};
